import { render, staticRenderFns } from "./ProcessBOM.vue?vue&type=template&id=2483a93e&"
import script from "./ProcessBOM.vue?vue&type=script&lang=js&"
export * from "./ProcessBOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports